import React, { useState, useEffect } from 'react';
import { Row, Col } from 'antd';

import { MainContainer } from './Footer.styles';
import { getYearInString } from 'utils/date';

import { SPECIAL_HOST_IDS } from 'utils/constants'; // Import the special host IDs

const Footer = ({ hostName, hostId }) => {
  const [isSpecialHost, setIsSpecialHost] = useState(false);

  useEffect(() => {
    const SpecialHostCheck = SPECIAL_HOST_IDS.includes(hostId);

    setIsSpecialHost(SpecialHostCheck);

    // console.log('SpecialHostCheck', SpecialHostCheck);
    // console.log('hostId', hostId);

    // // Check if the hostId is in the SPECIAL_HOST_IDS array and set isSpecialHost accordingly
    // console.log(SpecialHostCheck ? 'This host is special!' : 'This host is not special!');
  }, [hostId]);

  return (
    <>
      {isSpecialHost ? (
        <MainContainer>
          <Col>
            <span>{`@ ${getYearInString()} ${hostName}`}</span>
          </Col>
          {/* <Col>
            <Row gutter={24}>
              <Col>
                <a href={require('../../../../images/student-handbook.pdf')} rel="noopener noreferrer" target="_blank">
                  Student Handbook.pdf
                </a>
              </Col>

              <Col>
                <a href={require('../../../../images/do-and-dont.pdf')} rel="noopener noreferrer" target="_blank">
                  DO & DONT.pdf
                </a>
              </Col>
            </Row>
          </Col> */}
        </MainContainer>
      ) : (
        <MainContainer>
          <Col>
            <span>{`@ ${getYearInString()} ${hostName}`}</span>
          </Col>
          <Col>
            <span>Powered by HostPlatform</span>
          </Col>
        </MainContainer>
      )}
    </>
  );
};

export default Footer;
